import rp from '@reporting/rp-app-host';

/** The super tables p_SYNC_SERVERS knows how to merge. */
export type SyncTable = 'P_ACCOUNTING' | 'P_ACCOUNTING_GROUP' | 'P_ACCOUNTING_SECTION'
	| 'P_ACCESS_ACCOUNT' | 'P_ACCESS_ROLE' | 'P_ACCESS_ACCOUNT_RIGHT' | 'P_EMBEDDING';

/**
 * Nudge the cross server synchronization (p_SYNC_SERVERS).
 *
 * Groups, companies and number sections are written on the server of the administrator's current
 * company and only reach the other servers through that procedure, which a job runs every few
 * minutes. Calling it right after a write keeps the window short in which two servers can hand out
 * the same generated id (ID_GROUP, section ID, accounting number) without noticing each other.
 *
 * Every table is a full p_SYNC_TABLES round across the servers, so name in `tables` just the ones
 * the write changed. Without it the procedure runs its default selection, the same the scheduled
 * run takes - which merges P_ACCOUNTING_SECTION in the 19:xx hour only; naming a table explicitly
 * merges it right away. An empty list means nothing changed and nothing is called.
 *
 * A failure surfaces like that of any other request - the service reports it. A caller that only
 * nudges after a successful write need not await the promise; the scheduled run catches up.
 */
export async function synchronizeServers(tables?: SyncTable[]): Promise<void> {
	if (tables && !tables.length) return;
	await rp.ms('server').get('/sync', tables ? { tables: tables.join(',') } : undefined);
}
